import ExpertPharmacist from './ExpertPharmacist';

export default ExpertPharmacist;
